

import { __ } from '@wordpress/i18n';

export const contentOpt = [
	{ label: __('Content', 'mail-and-content-protect'), value: 'text' },
	{ label: __('Email', 'mail-and-content-protect'), value: 'email' },
	{ label: __('Phone Number', 'mail-and-content-protect'), value: 'phone' },
	{ label: __('Url', 'mail-and-content-protect'), value: 'url' },
]

export const generalStyleTabs = [
	{ name: 'general', title: __('General', 'mail-and-content-protect') },
	{ name: 'style', title: __('Style', 'mail-and-content-protect') }
];